import { createReducer } from "@reduxjs/toolkit";
import { APP_ERROR, APP_LOADING, APP_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const fullAppReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(APP_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(APP_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(APP_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default fullAppReducer;
